import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { NOTIFICATION_STATUS_CODE } from '../../enums/notification-status-code.enum';
import { ClientManagerInstanceToken, ClientManagerInterface } from '../../interfaces/client-manager.interface';
import { OdataResponse } from '../../interfaces/online-only.interface';
import {
    NotificationUpdateModel,
    ODataNotificationUpdateModel,
} from '../../models/low-level/notification-update.model';
import { isDefined } from '../../utilities/is-defined';
import { ODataUtilities } from '../../utilities/odata-utilities';
import { UriUtilitiesService } from '../uri-utilities/uri-utilities.service';
import { UserMasterService } from '../user-master/user-master.service';
import { OdataNotificationUpdateServiceInterface } from './odata-notification-update.interface';

@Injectable({
    providedIn: 'root',
})
export class OdataNotificationUpdateService implements OdataNotificationUpdateServiceInterface {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly translate: TranslateService,
        private readonly uriUtilities: UriUtilitiesService,
        private readonly http: HttpClient,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
        private readonly userMasterService: UserMasterService,
    ) {}

    public getNewNotifications(): Observable<NotificationUpdateModel[]> {
        const query = this.userMasterService.setSalesOrgAndPlantForUrl(
            this.uriUtilities.getUriForContent() + ENDPOINTS.WhatsNew,
        );

        return this.http.get<OdataResponse<ODataNotificationUpdateModel>>(query).pipe(
            map((response) => {
                if (this.clientManager.isPaceUS() && response) {
                    const data = response.d.results as ODataNotificationUpdateModel[];
                    data.forEach((d: ODataNotificationUpdateModel) => {
                        const usNotificationText = <string>this.translate.instant(
                            d.MessagetypeCSE !== NOTIFICATION_STATUS_CODE.AVR1
                                ? 'APP_HEADER_UPDATES_NOTIFICATION_RELEASED_P40'
                                : 'APP_HEADER_UPDATES_NOTIFICATION_CANCELLED_P40',
                            {
                                notificationNumber: d.NotificationNo,
                            },
                        );

                        d.MessageText = usNotificationText;
                    });
                }

                return ODataUtilities.transformResponseDataToArray(response.d)
                    .map((value: ODataNotificationUpdateModel) => NotificationUpdateModel.fromOData(value))
                    .filter(isDefined);
            }),
            catchError((err) => {
                this.log.error('getNewNotifications() - request error:  ' + JSON.stringify(err));
                return throwError(err);
            }),
        );
    }
}
